import { MessageScreen } from '@/components/MessageScreen/MessageScreen';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Add 'Turn on NFC' button and analytics
export const NFCNotEnabled = () => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('nfc_not_enabled');

  return (
    <MessageScreen
      iconPath={`${content.config.urlBase}${content.nfcNotEnabled.img.src}`}
      iconSize={content.nfcNotEnabled.img.width}
      title={content.nfcNotEnabled.title[locale]}
      titleSize={20}
      body={content.nfcNotEnabled.description[locale]}
    />
  );
};
